export default __webpack_public_path__ + "static/media/path.275ddc2e.svg";